var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.194336,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D2F5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8338 16.4526V18.601H22.2046V16.4526C22.2046 14.9756 20.9962 13.7672 19.5192 13.7672C18.0086 13.7672 16.8338 14.9756 16.8338 16.4526ZM15.2225 18.601V16.4526C15.2225 14.1029 17.1359 12.156 19.5192 12.156C21.8689 12.156 23.8159 14.1029 23.8159 16.4526V18.601H24.89C26.0649 18.601 27.0384 19.5744 27.0384 20.7493V27.1943C27.0384 28.4028 26.0649 29.3427 24.89 29.3427H14.1483C12.9399 29.3427 12 28.4028 12 27.1943V20.7493C12 19.5744 12.9399 18.601 14.1483 18.601H15.2225ZM13.6113 20.7493V27.1943C13.6113 27.4964 13.8462 27.7314 14.1483 27.7314H24.89C25.1586 27.7314 25.4271 27.4964 25.4271 27.1943V20.7493C25.4271 20.4808 25.1586 20.2122 24.89 20.2122H14.1483C13.8462 20.2122 13.6113 20.4808 13.6113 20.7493Z",
    fill: "#1D846F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockicon);
export default __webpack_public_path__ + "static/media/lockicon.cba4271d864af25f0d28c1af9f79fa87.svg";
export { ForwardRef as ReactComponent };